export default __webpack_public_path__ + "static/media/companies-coin-telegraph.5dcd2aa2.svg";